import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const CustomerDetailsPageContent = lazy(() => import("./CustomerDetailsPageContent"));

function CustomerDetailsPageInternal() {
    return (
        <DefaultPage>
            <CustomerDetailsPageContent />
        </DefaultPage>
    );
}

export const CustomerDetailsPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(CustomerDetailsPageInternal);
